import {useCallback, useEffect, useState} from 'react';
import axiosInstance from '../axiosInstance';

/**
 * Custom hook to fetch chat detail data
 * @param {number} id - The ID of the chat
 * @returns Array containing chat detail data
 */
const useGetChatDetail = ({id}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFetched, setIsFetched] = useState(false);

  const getData = useCallback(() => {
    if (!id) {
      return
    }

    setLoading(true)
    const baseUrl = window.localStorage.getItem("BaseURL")
    const endpoint = `/services/projectmanagement/api/ai-bot/chat/history/${id}`
    const fullUrl = baseUrl + endpoint;

    axiosInstance
      .get(fullUrl)
      .then((res) => {
        setData(res.data);
      })
      .catch(console.error)
      .finally(() => {
        setLoading(false)
        setIsFetched(true)
      });
  }, [id])

  useEffect(() => {
    getData()
  }, [getData])

  return {data, loading, isFetched};
}

export default useGetChatDetail;
